import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalChangingEpisode.scss';
import { Grid, cls, Row, Column } from '../../packages/components';
import PropTypes from 'prop-types';
import Asset from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';

const MAIN_CLASSNAME = 'aaf-modal-changing-episode';

const getSerieDescription = (episodeTitle, seasonNumber, episodeNumber) => {
    if(!episodeTitle || !seasonNumber || !episodeNumber){
        return "";
    }
    return `${Translator.get('playing_finplayer_abbreviationSeason_label', 'Temp.')} ${seasonNumber} | ${Translator.get('playing_finplayer_abbreviationEpisode_label', 'Ep.')} ${episodeNumber}: ${episodeTitle}`
}

const ModalChangingEpisode = ({ serieTitle, episodeTitle, seasonNumber, episodeNumber }) => {
    const modalProps = {
        childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
    };

    return (
        <ModalWrapper {...modalProps}>
            <Grid className={cls(`aaf-main-modal-options-event`)}>
                <Row>
                    <Column lg={12} className={`${MAIN_CLASSNAME}-serie-title`}>
                        {serieTitle}
                    </Column>
                    <Column lg={12} className={`${MAIN_CLASSNAME}-serie-description`}>
                        {getSerieDescription(episodeTitle, seasonNumber, episodeNumber)}
                    </Column>
                    <Column lg={12} className={`${MAIN_CLASSNAME}-loading`}>
                        <img src={Asset.get('finplayer_nextEpisode_loading', '/images/loadingBall.png')} alt="loading"/>
                    </Column>
                </Row>
            </Grid>
        </ModalWrapper>
    );
};

ModalChangingEpisode.propTypes = {
    serieTitle: PropTypes.string.isRequired,
    episodeName: PropTypes.string.isRequired, 
    seasonNumber: PropTypes.string.isRequired, 
    episodeNumber: PropTypes.string.isRequired
}

export default withOnClose(ModalChangingEpisode);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalChangingEpisode.jsx